import styled from "styled-components";
import { loadingIcon } from "../../constants/joshConstants";
import { Image_Domain } from "../../constants/joshConstants";
import { alignTxtType, clearFix, LHS, RHS } from "./Element";

const HeaderComp = styled.header`
    box-shadow:inset 0px -1px 0px #EEEEEE;padding:10px 0px 10px 0;position:fixed;left:0;top:0;width:100%;background-color:#fff;z-index:9999;
    ${LHS}{
         a{
             display:block;width:56px;
             span{
                display:inherit;
             }

         }
    }
    ${RHS}{
         ul{
            display:block;
             li{display:inline-block;vertical-align:top;
                a{
                  display:block;padding:9px 7px;border-radius:3px;
                  span{
                      background-position:left center;background-Size:auto 14px;padding:0 0 0 20px;display:block;font-size:10px;font-weight:700;color:#fff;
                  }
              }
             }
         }
    }
    ${clearFix()}
`;

const HeaderCompBackBtn = styled.header`
    box-shadow:inset 0px -1px 0px #EEEEEE;padding:10px 0px;position:fixed;left:0;top:0;width:100%;background-color:#fff;z-index:9999;
    .table{
        display:table;width:100%;
        .td{display:table-cell;vertical-align:middle;text-align:center;
            div.title{
                font-size:14px;font-weight:600;
            }.duet{
                p{
                    span.duetTitle{
                        font-size:14px;font-weight:600;
                    }
                    span.duethandel{
                        font-size:12px;font-weight:100;color:#757575;
                    }
                }
            }

        }.td.wid36{width:56px;padding-left:16px;}
    }
`;

const Container = styled.section`
    margin-top:50px;
    margin:${props => props.margin};
`;

const ProfileWrp = styled.section`
    ${({ alignTxt }) => alignTxtType(alignTxt)};
    padding:20px 16px;
    .profileImg{width:80px;height:80px;border-radius:100%;margin:auto auto 10px;position:relative;
        img{width:100%;height:100%;border-radius:100%;overflow:hidden;object-fit:cover;border:1px solid #e6e6e6;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
        span.verified{background-image:url("${Image_Domain}/static/images/josh/verified.svg");background-repeat:no-repeat;background-size:20px;display:inline-block;position:absolute;right:0px;bottom:5px;width:22px;height:22px;}
    }
    .profileDetails{
        margin-bottom:20px;
        p{color:#000000;font-weight:bold;font-size:14px;display:inline-block;margin-bottom:0px;}
        em{color:#757575;font-size:12px;display:block}
    }

`;

const ProfileStats = styled.ul`

    li{
        display:inline-block;min-width:90px;text-align:center;
        p{color:#000000;font-weight:bold;font-size:16px;display:block;margin-bottom:1px;}
        span{color:#757575;font-size:12px;display:block}
    }.bdrleftright{border-left:1px solid #EEEEEE;border-right:1px solid #EEEEEE}
`;

const ProfileBio = styled.div`
    color:#000;font-size:12px;max-height:60px;overflow:hidden;position:relative;margin-top:19px;line-height:18px;
    .shadow{background-image:linear-gradient(to bottom,rgba(255,255,255,0.5),rgba(255,255,255,1));width:100%;height:30px;position:absolute;bottom:0px;left:0px;display:block}
`;

const TabWrp = styled.ul`
    width:100%;font-size:0;margin-bottom:2px;
    li{width:50%;display:inline-block;box-shadow:inset 0px -1px 0px #EEEEEE, inset 0px 1px 0px #EEEEEE;
        a{display:block;padding:13px 8px;text-align:center;
            span{display:block;width:20px;height:20px;margin:auto;}
        }
    }
    li.active{box-shadow:inset 0px -1px 0px #EA4E60, inset 0px 1px 0px #EEEEEE;}

`;

const TabMenu = styled.ul`
display:table;font-size:0px;width:100%;margin-bottom:10px;
  li{display:table-cell;vertical-align:middle;text-align:center;padding:13px;box-shadow:inset 0px -2px 0px transparent;
    span{display:inline-block;margin:auto;background-position:center;width:20px;height:20px;}
  }.active{box-shadow:inset 0px -2px 0px #E94E60;}
`;



const ImgWrp = styled.ul`
    width:100%;font-size:0;
    li{width:50%;display:inline-block;border-top:1px solid #fff;border-bottom:1px solid #fff;position:relative;
        figure{
            img{width:100%;height:100%;border-radius:2px;overflow:hidden;}
        }
        span{font-size:12px;color:#fff}

    }
    li:nth-child(even){border-left:1px solid #fff}
    li:nth-child(odd){border-right:1px solid #fff}
`;

const DetailsVidWrp = styled.section`
    position:relative;
    video{
        width:100%;height:100%;
    }
    .playOverlay{position:absolute;background-color:transparent;height:100%;width:100%;z-index:999988}
    .takeatour{position:absolute;background-color:rgba(0, 0, 0, 0.8);height:100%;width:100%;z-index:9999999;background-image:url("${Image_Domain}/static/images/josh/takeatour.svg");background-repeat:no-repeat;background-position:center center;}
    /* video[poster]{
        height:100%;
        width:100%;
        } */
    .userDetails{position:absolute;bottom:0px;left:0px;background:linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, #000000 100%);width:100%;padding:12px 16px 22px 16px;width:100%;
        .rich_content{color:#eee;font-size:12px;margin-bottom:6px;max-height:47px;overflow:hidden;line-height:16px;
            strong{
                a{display:inline-block;font-weight:bold;}
            }
            a{display:inline-block;font-weight:bold;}
        }
    }
    .videoWrappHack{
        video{object-fit:cover;}
    }
`;

const DetailsVidProfileWrp = styled.ul`
    display:block;font-size:0;
    li{
        display:inline-block;margin-right:8px;vertical-align:middle;
        .profleImg{
            width:32px;height:32px;overflow:hidden;border-radius:99%;border:1px solid #fff;
            img{width:100%;height:100%;overflow:hidden;border-radius:99%;object-fit:cover;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
        }
        span{font-size:14px;font-weight:600;color:#eee;}
    }
    li:last-child{
       margin:0px;
    }
`;

// for contest >>>>> 5th Aug 2020
const HeaderImgWrp = styled.section`
    width:100%;height:auto;
    img{
        width:100%;height:auto;
    }
`;

const ContestBio = styled.div`
    color:#757575;font-size:12px;line-height:20px;padding:10px 16px 10px;
`;

const ContestWrp = styled.section`
    /* padding:10px 16px 0px; */
`;

const ContestDeatils = styled.section`
    font-size:0;padding:16px 0px;display:table;width:calc(100% - 52px);margin:0 16px;box-shadow: rgb(238, 238, 238) 0px -0.5px 0px inset;
    .contestImg{display:table-cell;vertical-align:top;width:30px;
        .imgHolder{width:50px;height:50px;border-radius:99%;overflow:hidden;margin:auto;
            img{width:100%;height:100%;border-radius:99%;overflow:hidden;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
            }
        }
    .contestInfo{display:table-cell;vertical-align:top;padding-left:8px;
        p{font-size:12px;color:#747474;display:block;margin-bottom:5px;}
        span{font-size:9px;color:#9F9F9F;display:inline-block;display:block;margin-bottom:5px;
            em.block{color:#000}
        }
        em.circle{width:3px;height:3px;border-radius:100%;background-color:#C4C4C4;margin:0 5px;display:inline-block;position:relative;top:-1px;display:none;}

    }
`;




const ContestImgWrp = styled.table`
     display:table;width:100%;border-collapse:collapse;
    tr{
       td{
        width:50%;vertical-align:middle;background-color:#000;position:relative;border-bottom:3px solid #fff;
        .imgHolder{
            position:relative;height:150px;
            img{width:100%;height:100%;object-fit:cover}
            .shadowrp{background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);position:absolute;left:0;bottom:0;width:100%;height:50px}
        }
        .bagde{position:absolute;top:6px;right:12px;background:rgba(255, 255, 255, 0.74);border-radius:2px;color:#000;font-size:10px;padding:2px 4px;}
        .view{background-position:left center;padding:0 0 0 24px;position:absolute;left:14px;bottom:14px; font-size:12px;display:inline-block;color:#fff;background-size:18px 12px}
        .heart{background-position:left center;padding:0 0 0 24px;position:absolute;left:12px;bottom:12px; font-size:12px;display:inline-block;color:#fff;background-size:14px 12px}
       }
       td:nth-child(even){border-left:3px solid #fff}
       td:nth-child(odd){border-right:3px solid #fff}
    }
`;


const ContestStats = styled(ProfileStats)`
    text-align:center;padding:10px 16px 0;
    li{
        min-width:90px;
    }
`;

const DownloadAppWrp = styled.section`
    position:fixed;top:0;left:0;z-index:999999;background:rgba(0,0,0,0.8);width:100%;height:100%;
    .alertBox{
        width:276px;background:linear-gradient(90.33deg, #72D3E8 2.63%, #E55379 99.73%);left:calc(50% - 138px);top:calc(50% - 65px);position:absolute;border-radius:10px;padding:4px;
        .textContent{
            width:100%;height:100%;background-color:#fff;border-radius:inherit;padding:30px;position:relative;
            p{color:000;font-size:11px;line-height:17px;font-weight:400;text-align:center;margin-bottom:12px}
            .plyStore{width:130px;height:40px;margin:auto;
                img{width:100%;height:auto}
            }
            .closeBtn{position:absolute;right:0px;top:0px;width:36px;height:36px;display:block;background-image:url("${Image_Domain}/static/images/josh/pop-close.svg");background-size:8px 8px;background-position:center center;background-repeat:no-repeat;cursor:pointer;}
        }
    }
`;


// updated on 17 Aug

const StatsWrp = styled(DetailsVidProfileWrp)`
    display:inline-block;
    li{
        span{font-size:12px;color:#fff;font-weight:normal}

    }
`;
const StatsBarUpdated = styled.section`
    ${LHS}{
          padding-top:0px;

    }
    ${RHS}{
        position:relative;
         .animatBox{
             .musicIcon{
                background:linear-gradient(140.21deg, #181818 21.26%, #353434 46.42%, #333333 48.32%, #1F1E1D 74.41%), radial-gradient(50.51% 50.7% at 50% 50%, #232323 0%, #202020 99.5%, #E9E9E9 100%);width:48px;height:48px;border-radius:99%;position:relative;
                img{width:26px;height:26px;position:absolute;left:calc(50% - 13px);top:calc(50% - 13px);border-radius:99%}
             }
         }
         .anitmation {-webkit-animation:spin 3s linear infinite;-moz-animation:spin 3s linear infinite;animation:spin 3s linear infinite;}
          @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
          @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
          @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

          .melody{
              /* position:absolute; */
              transform: rotate3d(0, 5, -4, 45deg);position:absolute;left:-20px;bottom:-20px;

              .commonCode{width:20px;height:20px;display:inline-block;position:relative;background-repeat:no-repeat;animation-fill-mode:forwards;animation-name:melodyAnimation;animation-iteration-count:infinite;animation-timing-function:linear;opacity:0;animation-direction:reverse;bottom:0}

              .melody-1{background-image:url("${Image_Domain}/static/images/josh/icon-melody2.svg");}
              .melody-2{background-image:url("${Image_Domain}/static/images/josh/icon-melody1.svg");left:-10px}
              .one {-webkit-animation: melodyAnimation 6s infinite 0s;animation: melodyAnimation 6s infinite 0s;}
              .two {-webkit-animation: melodyAnimation 6s infinite 3s;animation: melodyAnimation 6s infinite 3s;}
              @keyframes melodyAnimation {
                0%   {bottom:10px;opacity:1;}
                100% {bottom:60px;opacity:0;}
                }
          }
    }
    ${clearFix()}
`;

const ErrorBlock = styled.section`
    position:absolute;left:0;top:0;width:100%;height:100%;
    .errorMsgBlock{
        text-align:center;position:absolute;top:calc(50% - 70px);left:calc(50% - 75px);
        .imgCont{
            width:75px;margin:0 auto 10px;
            img{width:100%;height:auto}
        }
        .errorMsg{font-weight:400;font-size:16px;color:#000000;margin-bottom:10px;}
        .backToHome{background-color:#EA4E60;padding:10px 25px;border-radius:4px;color:#fff;display:inline-block}

    }

`;

const LeftSIdeMenu = styled.section`
    position:fixed;right:16px;bottom:22px;
    ul{display:block;font-size:0;text-align:center;width:36px;
        li{display:block;width:30px;margin-bottom:12px;
            .profleImg{
            width:36px;height:36px;overflow:hidden;border-radius:99%;border:1px solid #fff;
                img{width:100%;height:100%;overflow:hidden;border-radius:99%;object-fit:cover;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
            }
           a{
               display:block;text-align:center;
               span{margin:auto auto 3px auto;display:block}
                strong{font-size:10px;font-weight:400;color:#fff;display:block}
           }

        }li:last-child{margin-bottom:0}
        li.anim{
            position:relative;width:36px;height:36px;margin-top:22px;
            .animatBox{
                .musicIcon{width:36px;height:36px;border-radius:99%;position:relative;
                    img{width:100%;height:100%;position:absolute;left:calc(50% - 18px);top:calc(50% - 18px);border-radius:99%;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
                }
            }
            .anitmation {-webkit-animation:spin 3s linear infinite;-moz-animation:spin 3s linear infinite;animation:spin 3s linear infinite;position:fixed;}
            @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
            @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
            @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

            .melody{
                /* position:absolute; */
                transform: rotate3d(0, 5, -4, 45deg);position:absolute;left:-20px;bottom:-20px;

                .commonCode{width:20px;height:20px;display:inline-block;position:relative;background-repeat:no-repeat;animation-fill-mode:forwards;animation-name:melodyAnimation;animation-iteration-count:infinite;animation-timing-function:linear;opacity:0;animation-direction:reverse;bottom:0}

                .melody-1{background-image:url("${Image_Domain}/static/images/josh/icon-melody2.svg");}
                .melody-2{background-image:url("${Image_Domain}/static/images/josh/icon-melody1.svg");left:-10px}
                .one {-webkit-animation: melodyAnimation 6s infinite 0s;animation: melodyAnimation 6s infinite 0s;}
                .two {-webkit-animation: melodyAnimation 6s infinite 3s;animation: melodyAnimation 6s infinite 3s;}
                @keyframes melodyAnimation {
                    0%   {bottom:10px;opacity:1;}
                    100% {bottom:60px;opacity:0;}
                    }
            }
        }
    }

`;

const VidDuration = styled.div`
    position:absolute;width:100%;height:2px;background-color:#F01776;width:${props => props.width};bottom:0;left:0;z-index:1000000;
`;

const TagsDeatils = styled.div`
    text-align:center;
    p{font-weight:bold;font-size:14px;color:#000;text-align:center;margin-bottom:20px}
`;

const SearchWrp = styled.section`
    /* padding:0 16px; */
    h2{color:#EA4E60;font-size:14px;font-weight:700;padding:0 16px}

`;

const HorizentalScroll = styled.ul`
     white-space:nowrap;overflow-x:auto;padding:10px 16px;font-size:0px;
     &&.MB20{margin-bottom:20px;}
     &&.MB10{margin-bottom:10px;}
     &&.noScroll{ white-space:normal;}
     li{
        white-space:normal;display:inline-block;margin-right:10px;vertical-align:top;

        .bannerImag{width:250px;height:140px;
            img{width:100%;height:100%}
        }
        .duetImg{width:100px;height:100px;
            img{width:100%;height:100%}
        }
        .creators{
            width:50px;
            .createPro{
                width:50px;height:50px;position:relative;
                    img{width:100%;height:100%;border-radius:99%;}
                    .verfied{position:absolute;bottom:-5px;right:-4px;width:18px;height:18px;background-image:url("${Image_Domain}/static/images/josh/verified.svg");background-repeat:no-repeat;display:inline-block}
            }
            .name{font-size:9px;color:#000;font-weight:400;text-align:center}
        }
        .creatorsType1{
            width:126px;display:table;
            .createPro{
                width:50px;height:50px;position:relative;display:table-cell;vertical-align:top;
                    img{width:100%;height:100%;border-radius:99%;}
                    .verfied{position:absolute;bottom:-5px;right:-4px;width:18px;height:18px;background-image:url("${Image_Domain}/static/images/josh/verified.svg");background-repeat:no-repeat;display:inline-block}
            }
            .deatils{
                width:calc(100% - 25px);display:table-cell;vertical-align:top;padding-left:6px;
                .name{font-size:9px;color:#000;font-weight:400;display:block}
                em{font-size:8px;color:#757575;font-weight:400;display:block}
            }
        }

        .tags{
            border:1px solid #DFDFDF;border-radius:3px;padding:10px 11px;margin-bottom:10px;
            span{font-weight:700;}
        }
        .bg1{background-color:#FD6060;text-align:center}
        .bg2{background-color:#EFAA02;text-align:center}
        .bg3{background-color:#F77737;text-align:center}

     }
     li.MR20{margin-right:20px}
     li.wid33{width:calc(33.33% - 7px)}
     li.wid25{width:calc(25% - 25px);margin-right:25px;margin-bottom:20px;text-align:center;
        span{margin-bottom:8px;}
        p{font-weight:400;font-size:9px;color:#000}
     }
     li:last-child{margin-right:0}

`;

const SettingWerp = styled.section`
    display:block;padding:0 16px;
    ul{display:inherit;font-size:0px;
        li{display:inherit;border-bottom:1px solid red;
            a{
                padding:8px 0;display:inherit;background-image:url("${Image_Domain}/static/images/josh/arrow-white.svg");background-repeat:no-repeat;background-size:14px 14px;background-position:right center;
            }
        }
        li:last-child{border-bottom:0px solid #EEEEEE;}
    }
`;



const ChangeLag = styled.div`
    padding:16px;
    .langSele{
        h2{font-size:12px;color:#000;font-weight:bold;margin-bottom:18px;text-align:center;}
        ul{display:block;
            li{display:inline-block;width:50%;padding:0 0 15px 0 !important;
                .lang{padding:8px 6px;cursor:pointer;text-align:center;background:#EFEEEE;border:1px solid rgba(255, 255, 255, 0.2);border-radius: 6px;transition:background,border  0.3s linear;
                    /* em{display:inline-block;border-radius:99%;padding-top:8px;font-size:13px;font-weight:400;color:#fff;width:32px;height:32px;text-align:center} */
                    span{display:inline-block;font-weight:400;font-size:14px;color:#000;transition:color  0.2s linear;line-height:16px;}
                }

                .lang.active{
                    border:1px solid #EA4E60;background-color:#EA4E60;
                    span{color:#fff;}
                }
            }
            .mr0{margin-right:0px;}
            li:nth-child(odd){padding-right:15px !important}
            li:nth-child(even){padding-left:15px !important}
        }
    }

    .saveBtn{color:#000;font-size:14px;font-weight:600;padding:13px 10px;position:fixed;bottom:0px;left:0px;display:block;width:100%;text-align:center;text-transform:capitalize;cursor:pointer;background:#EFEFEF}
    .saveBtn.active{background:#EA4E60;color:#fff}


`;


const AboutUs = styled.section`
    padding:16px;
    .textCont{
        margin-bottom:16px;border-bottom:1px solid #EEEEEE;padding-bottom:16px;
        h2{font-size:20px;color:#000;font-weight:bold;margin-bottom:30px;}
        ${LHS}{
            span{font-size:12px;color:#000;font-weight:400;display:inline-block;padding:10px 0}
        }
        ${RHS}{
            em{font-size:12px;color:#000;font-weight:400;display:inline-block;font-weight:bold;padding:10px 10px;border:1px dashed #000;user-select:all;text-align:center}
                a{font-size:12px;color:#000;font-weight:400;display:inline-block;font-weight:bold;padding:10px 10px;cursor:pointer;}
        }
        ${clearFix()}
    }
    .copyRight{
        .copyrightText{font-size:10px;color:#c1c1c1;display:block;}
        /* strong.dot{width:4px;height:4px;border-radius:100%;background-color:#C4C4C4;display:inline-block;margin:0 10px;position:relative;top:-2px;} */
    }
    .appVersion{font-size:10px;color:#B3B3B3;padding:13px 10px;position:fixed;bottom:0px;left:0px;display:block;width:100%;text-align:center;text-transform:capitalize}

`;

const IconTable = styled.div`
    display:table;
    margin:${props => props.margin};
    padding:${props => props.padding};
    cursor:${props => props.Cursor};
    .tr{display:table-cell;vertical-align:middle}
`;

const UserDetailsWrp = styled.div`
  display:table;width:100%;
  .TC{display:table-cell;vertical-align:top;
    picture{width:75px;height:75px;border-radius:99%;overflow:hidden;display:block;
      img{width:100%;height:100%;}
    }
    h3{font-size:16px;color:#000000;margin-bottom:4px;font-weight:bold;display:inline-block}
    h3.varified{background-image:url(${Image_Domain}/static/images/josh_2/verified.svg);background-repeat:no-repeat;background-size:12px 12px;background-position:right center;padding-right:18px}
    p{font-size:12px;color:#757575;margin-bottom:13px;}
    ul{display:block;font-size:0px;text-align:center;
      li{display:inline-block;width:33.33%;
        span{font-size:14px;color:#000;display:block;margin-bottom:2px;font-weight:600}
        em{font-size:12px;color:#757575;display:block;margin-bottom:2px}
      }
    }
  }
  .wid75{width:75px}
  .PL10{padding-left:10px;}
`
const UserProfileDetails = styled.section`
  padding:16px 14px 0;margin-top:50px;position:relative;
`;

const ConfiguredBtn = styled.ul`
  display:table;font-size:0px;width:100%;margin-bottom:10px;
  li{display:table-cell;vertical-align:middle;
    a{
      display:block;padding:10px 12px;border:1px solid #EEEEEE;border-radius:2px;margin-right:10px;text-align:center;position:relative;
      span{display:inherit;margin:auto;background-position:center;width:16px;height:16px;background-size:auto 16px;}
      em{color:#757575;font-size:13px;font-weight:bold}
    }
    .P8{padding:10px 9px}
    .add{
      strong{background-position:center;width:12px;height:12px;background-size:auto 12;background-image:url(${Image_Domain}/static/images/josh_2/icb_addsocial.svg);background-repeat:no-repeat;position:absolute;right:-5px;bottom:-5px}
    }
  }.wid40{width:40px}
  .follow{
    a{background:#EA4E60;
      em{color:#fff}
    }
  }
  .Following{
    a{background:#EEEEEE;
      em{color:#757575}
    }
  }
  li:last-child a{margin-right:0;}
`;

const UserBio = styled.div`
  position:relative;margin-bottom:10px;
  .textContent{
    font-size:12px;color:#000;height:50px;overflow:hidden;max-height:50px;
    strong{font-weight:bold;}
  }
  .seeMore{position:absolute;bottom:0px;display:block;text-align:center;width:100%;}
`;

const ProfileExplore = styled.section`
    background:rgba(255, 255, 255, 0.12);border-radius:4px;padding:3px 6px;margin:10px 0;
    .table{display:table;width:100%;
        .td{display:table-cell;vertical-align:middle;
            &.wd22{width:22px;}
            .icn{width:22px;height:22px;border-radius:99%;
                img{width:100%;height:100%;border-radius:99%;}
            }
            p{font-weight:400;font-size:10px;line-height:14px;color:#FFFFFF;margin-left:6px;}
            a{font-weight:600;font-size:10px;line-height:14px;color:#FFFFFF;text-transform:uppercase;text-align:right;margin-left:10px;}
        }
    }
    strong{font-weight:bold;}
`;


export { TabMenu, HeaderComp, Container, ProfileWrp, ProfileStats, ProfileBio, TabWrp, ImgWrp, DetailsVidWrp, DetailsVidProfileWrp, StatsWrp, HeaderCompBackBtn, HeaderImgWrp, ContestBio, ContestDeatils, ContestWrp, ContestImgWrp, ContestStats, DownloadAppWrp, StatsBarUpdated, ErrorBlock, SettingWerp, HorizentalScroll, LeftSIdeMenu, VidDuration, TagsDeatils, SearchWrp, ChangeLag, AboutUs, IconTable, UserDetailsWrp, UserProfileDetails, UserBio, ConfiguredBtn, ProfileExplore };

